import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChangeEmailDialogComponent } from './change-email-dialog.component';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { FocusOnFirstInvalidFieldModule } from '@go-modules/directives/focus-on-first-invalid-field';
import { PasswordVisibilityToggleModule } from '@go-modules/directives/password-visibility-toggle/password-visibility-toggle.module';
import { EmailVerificationModule } from '@go-modules/components/email-verification/email-verification.module';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		TranslateModule,
		FocusOnFirstInvalidFieldModule,
		GoMaterialModule,
		PasswordVisibilityToggleModule,
		EmailVerificationModule
	],
	declarations: [
		ChangeEmailDialogComponent
	],
	exports: [
		ChangeEmailDialogComponent
	]
})
export class ChangeEmailDialogModule {}
